const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkonaDatawarehouse2Biala(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 59 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "square",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,-200.719,-185.685)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.24737,0,0,1.24737,603.029,-71.8326)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.248701,0,0,0.248701,-478.78,-31.6426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1282.42,1771.74C1282.41,1771.67 1282.4,1771.6 1282.4,1771.53C1282.4,1761.82 1364.41,1753.94 1465.42,1753.94C1365.13,1753.94 1283.58,1761.89 1282.42,1771.74ZM1465.42,1753.94C1566.42,1753.94 1648.43,1761.82 1648.43,1771.53C1648.43,1771.6 1648.42,1771.67 1648.42,1771.74C1647.26,1761.89 1565.7,1753.94 1465.42,1753.94ZM1648.42,1771.74C1648.42,1771.81 1648.43,1771.88 1648.43,1771.95L1648.43,1860.24C1648.43,1863.37 1640.26,1866.33 1625.91,1868.89C1640.26,1871.4 1648.43,1874.29 1648.43,1877.35C1648.43,1877.42 1648.42,1877.49 1648.42,1877.56C1648.05,1874.46 1639.7,1871.54 1625.29,1869C1593.99,1874.52 1534.1,1878.25 1465.42,1878.25C1396.74,1878.25 1336.84,1874.52 1305.54,1869C1291.13,1871.54 1282.78,1874.46 1282.42,1877.56C1282.41,1877.49 1282.4,1877.42 1282.4,1877.35C1282.4,1874.29 1290.57,1871.4 1304.92,1868.89C1290.57,1866.33 1282.4,1863.37 1282.4,1860.24L1282.4,1771.95C1282.4,1771.88 1282.41,1771.81 1282.42,1771.74C1283.58,1781.35 1365.13,1789.12 1465.42,1789.12C1565.7,1789.12 1647.26,1781.35 1648.42,1771.74ZM1648.42,1877.56C1648.42,1877.63 1648.43,1877.7 1648.43,1877.77L1648.43,1966.06C1648.43,1976 1566.42,1984.07 1465.42,1984.07C1364.41,1984.07 1282.4,1976 1282.4,1966.06L1282.4,1877.77C1282.4,1877.7 1282.41,1877.63 1282.42,1877.56C1283.58,1887.17 1365.13,1894.94 1465.42,1894.94C1565.7,1894.94 1647.26,1887.17 1648.42,1877.56Z",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "7.89px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.24737,0,0,1.24737,603.029,-71.8326)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.168625,0,0,0.168625,-466.672,196.296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1989,1000L2021.01,967.993L2041.7,988.687L2063.06,978L2063.06,948.747L2112,948.747L2112,976L2140,988L2160,969L2190.92,999.923L2170.84,1020.01L2182,1046L2210,1046L2210,1093L2184,1093L2173,1119L2191.57,1137.57L2158.63,1170.52L2141.88,1153.77L2114,1163L2114,1191L2063.06,1191L2063.06,1163L2041,1153L2021.21,1172.8L1987.46,1139.05L2005.91,1120.59L1997,1094L1969,1094L1969,1049L1997,1049L2008,1021L1989,1000Z",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "11.48px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.24737,0,0,1.24737,603.029,-71.8326)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.149168,0,0,0.149168,-428.478,215.005)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2106,
    cy: 1084,
    r: 39,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "12.97px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.24737,0,0,1.24737,603.029,-71.8326)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.257261,0,0,0.257261,-656.121,97.8321)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2106,
    cy: 1084,
    r: 39,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "7.52px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonaDatawarehouse2Biala);
export default __webpack_public_path__ + "static/media/IkonaDATAWAREHOUSE_2_biala.6a71b21c8b516540a2926a84485eeb8e.svg";
export { ForwardRef as ReactComponent };